import MuiAlert from '@mui/material/Alert'
import { getIconBySeverity } from '@/shared/utils/getIconBySeverity'
import IconButton from '@/shared/components/IconButton/IconButton'
import { ReactNode } from 'react'
import { alertStyles } from './Alert.styles'
import styles from './Alert.module.scss'

interface AlertProps {
  message: string | ReactNode
  severity: 'error' | 'warning' | 'info' | 'success'
  /**
   * Omit for an alert that is part of the page rather than a response to
   * something — an empty state, or a standing note about a feature. Without a
   * handler there is nothing for a close button to do, so it is not rendered.
   */
  onClose?: () => void
}

function Alert(props: AlertProps) {
  const { message, severity, onClose } = props
  const icon = getIconBySeverity(severity, 'icon-medium')
  return (
    <MuiAlert
      sx={alertStyles}
      icon={icon}
      severity={severity}
      variant="filled"
      action={
        onClose ? (
          <IconButton
            color="tertiary"
            icon="las la-times-circle icon-medium"
            onClick={onClose}
          />
        ) : undefined
      }
    >
      <p className={`${styles.alertMessage} body-medium`}>{message}</p>
    </MuiAlert>
  )
}

export default Alert
